import cn from 'classnames';
import { BadgeColor } from '@odin-labs/components';
import {
  AnnouncementStatus,
  AnnouncementType,
  JobsiteAccessStatusType,
  JobsiteAnnouncement,
} from 'apollo/generated/client-operations';
import {
  Announcement,
  CreateAnnouncementData,
} from 'containers/announcements/types';

export type AnnouncementInput = {
  announcement: Partial<Announcement> | Partial<CreateAnnouncementData>;
};

export type RecipientCountsProps = {
  counts: {
    totalCount: number;
    totalReachableCount: number;
  };
  announcement?: Omit<Partial<JobsiteAnnouncement>, 'files'>;
};

export const classes = {
  section: cn(
    'odin-space-y-5 sm:odin-space-y-9 odin-divide-y-2 odin-divide-gray-900',
  ),
  sectionHeader: cn(
    'odin-text-lg odin-font-medium odin-leading-6 odin-text-gray-900',
  ),
  fourspan: cn('odin-col-span-4'),
  children: cn(
    'odin-mt-5 md:odin-mt-0 odin-col-span-8 odin-grid odin-grid-cols-1 odin-gap-6',
  ),
  announcementCard: cn(
    'odin-flex odin-gap-5 odin-flex-col odin-overflow-y-auto',
  ),
  recipientCountsContainer: cn(
    'odin-flex odin-gap-5 odin-flex-col odin-overflow-y-auto',
  ),
  hbar: cn('odin-bg-gray-200'),
  header: cn(
    `odin-mb-1.5 odin-block odin-text-sm odin-font-medium odin-text-gray-900
     odin-col-span-2 odin-mt-2 odin-align-middle odin-text-left`,
  ),
  title: cn(
    `odin-mb-1.5 odin-block odin-text-sm odin-text-gray-900
     odin-col-span-2 odin-mt-2 odin-align-middle odin-text-left`,
  ),
  value: cn('odin-col-span-2 odin-align-middle odin-text-left'),
};

export const accessStatusDescription: Record<JobsiteAccessStatusType, string> =
  {
    AccessAllowed: 'Currently allowed on site',
    CurrentlyOnsite: 'Currently on site',
    RecentlyOnsite: 'On site',
  };

export const announcementTypeColor: Record<AnnouncementType, BadgeColor> = {
  Email: 'purple',
  Sms: 'blue',
};

export const announcementStatusColor: Record<AnnouncementStatus, BadgeColor> = {
  Sent: 'green',
  Draft: 'yellow',
  Processing: 'blue',
  Scheduled: 'yellow',
  Archived: 'gray',
};

export const warningMessage =
  'Based on your filter criteria, no workers will receive this announcement: please update your filter criteria';
